import { scarpaGray300, spanishViridian500, strokesAAA } from '@habitech/shared';
import styled from 'styled-components';

interface TabsContainerProps {
    active: boolean;
}

export const TabsContainer = styled.div<TabsContainerProps>`
    display: flex;
    justify-content: space-between;
    max-width: 735px;
    padding-bottom: 12px;
    margin-bottom: 12px;
    overflow-y: auto;

    @media ${({ theme }) => theme.screenSizes.laptop} {
        overflow-y: unset;
    }
`;

interface TabProps {
    active: boolean;
    isDisabled?: boolean;
}

export const Tab = styled.div<TabProps>`
    text-align: center;
    width: 100%;
    padding: 16px;
    cursor: pointer;
    background-color: white;
    color: ${(props) => (props.active ? spanishViridian500 : props.isDisabled ? scarpaGray300 : strokesAAA)};
    cursor: ${(props) => (props.active ? 'pointer' : props.isDisabled ? 'wait' : 'pointer')};
    border-bottom: 4px solid ${(props) => (props.active ? spanishViridian500 : 'transparent')};
    font-weight: ${(props) => (props.active ? 'bold' : 'normal')};
    font-size: ${(props) => (props.active ? '16px' : '14px')};
    transition: border-bottom 0.3s, color 0.3s;
    white-space: nowrap;
`;
